import script from "./CmsLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./CmsLogin.vue?vue&type=script&setup=true&lang=ts"

import "./CmsLogin.vue?vue&type=style&index=0&id=5223ff2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5223ff2d"]])

export default __exports__